import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { ToggleButtonGroupStyle } from './styles';
import { RcToggleButtonGroupClasses } from './utils';
var _RcToggleButtonGroup = forwardRef(function (inProps, ref) {
    var props = useThemeProps({
        props: inProps,
        name: 'RcToggleButtonGroup',
    });
    var classesProp = props.classes, children = props.children, variant = props.variant, size = props.size, rest = __rest(props, ["classes", "children", "variant", "size"]);
    var classes = useMemo(function () { return combineClasses(RcToggleButtonGroupClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiToggleButtonGroup, __assign({}, rest, { ref: ref, classes: classes }), children.map(function (x, i) {
        // * that key follow mui key logic
        // eslint-disable-next-line react/no-array-index-key
        return React.cloneElement(x, { key: "." + i, size: size, variant: variant });
    })));
});
var RcToggleButtonGroup = styled(_RcToggleButtonGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ToggleButtonGroupStyle);
RcToggleButtonGroup.defaultProps = {
    size: 'medium',
    variant: 'standard',
};
RcToggleButtonGroup.displayName = 'RcToggleButtonGroup';
export { RcToggleButtonGroup };
var templateObject_1;
